import { create } from 'zustand';

export type AutoBetTourStage = 'login' | 'deposit-entry' | 'sui-wallet';

interface AutoBetTourState {
	isActive: boolean;
	stage: AutoBetTourStage | null;
	start: () => void;
	setStage: (stage: AutoBetTourStage) => void;
	stop: () => void;
}

const initialState: Pick<AutoBetTourState, 'isActive' | 'stage'> = {
	isActive: false,
	stage: null,
};

export const useAutoBetTourStore = create<AutoBetTourState>((set) => ({
	...initialState,
	start: () =>
		set(() => ({
			isActive: true,
			stage: 'login',
		})),
	setStage: (stage) =>
		set((state) => {
			if (!state.isActive) {
				return state;
			}
			return {
				...state,
				stage,
			};
		}),
	stop: () => set(initialState),
}));
